import { useState } from "react";
import styled from "styled-components";

const Div = styled.div`
  margin-bottom: 10px;
  padding: 10px 0;

  input {
    padding: 5px 8px;
    display: inline-block;
    margin-right: 8px;
  }
  button {
    padding: 5px 8px;
    display: inline-block;
  }
`;

function AddItem({ addItemList }) {
  const [itemId, setItemId] = useState(4);
  const [itemText, setItemText] = useState("");

  const addItem = (e) => {
    setItemText(e.target.value);
  };

  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      handleAdd();
    }
  };

  const handleAdd = () => {
    addItemList(itemId, itemText);
    setItemText("");
    setItemId(itemId + 1);
  };

  return (
    <Div>
      <input
        value={itemText}
        type="text"
        onChange={addItem}
        onKeyPress={onKeyPress}
      />
      <button onClick={handleAdd}>생성</button>
    </Div>
  );
}

export default AddItem;
